module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n\t <my-compania-consultar></my-compania-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/compania/compania.component.html
// module id = ./src/app/compania/compania.component.html
// module chunks = main